import { getResponseErrorStatusCode } from '../../../../utils/get-response-error-status-code';
export var SeatAvailabilityForShowtimeErrorCodeV1;
(function(SeatAvailabilityForShowtimeErrorCodeV1) {
    SeatAvailabilityForShowtimeErrorCodeV1[SeatAvailabilityForShowtimeErrorCodeV1[// The session has no allocated seating, therefore there's no information about availability
    "NoAllocatedSeats"] = 12002] = "NoAllocatedSeats";
    SeatAvailabilityForShowtimeErrorCodeV1[SeatAvailabilityForShowtimeErrorCodeV1["ShowtimeUnavailable"] = 12003] = "ShowtimeUnavailable";
})(SeatAvailabilityForShowtimeErrorCodeV1 || (SeatAvailabilityForShowtimeErrorCodeV1 = {}));
export class SeatAvailabilityForShowtimeErrorV1 extends Error {
    constructor(errorCode){
        const error = `Failed to get seat layout information. API error code ${errorCode}: ${SeatAvailabilityForShowtimeErrorCodeV1[errorCode]}`;
        super(error);
        this.errorCode = errorCode;
    }
}
export async function getSeatAvailabilityForShowtimeErrorV1(error) {
    const errorCode = await getSeatAvailabilityErrorCode(error);
    return errorCode && Object.values(SeatAvailabilityForShowtimeErrorCodeV1).includes(errorCode) ? new SeatAvailabilityForShowtimeErrorV1(errorCode) : error;
}
async function getSeatAvailabilityErrorCode(error) {
    const statusCode = getResponseErrorStatusCode(error);
    if (statusCode === 400) return 12002;
    if (statusCode === 404) return 12003;
    return undefined;
}

//# sourceMappingURL=seat-availability-for-showtime-error.js.map